@for (item of optionList; track item; let last = $last) {
  <a class="option"
    [ngClass]="{
      'option--last-hidden-divider-pad': !displayLastDivider && last,
      'option--default': variant === 'default',
      'option--simple': variant === 'simple',
      'option--bold': fontType === 'bold',
      'option--disabled': item.disabled,
    }"
    [routerLink]="!item.disabled ? item.route : null"
    [queryParams]="item.queryParams"
    [queryParamsHandling]="item.queryParamsHandling"
    [replaceUrl]="item.replaceUrl"
    (click)="!item.disabled && selectOption(item.selectedValue)"
  >

    @if (item.icon) {
      <div class="option-icon">
        @if (item.disabled) {
          <svg-icon
            class="icon-size disabled-lock-icon"
            [ngStyle]="{'--icon-size': iconSize + 'px'}"
            [src]="'assets/icons/lock.svg'"
          ></svg-icon>
        } @else if (!item.imgIcon) {
          <svg-icon
            class="icon-size"
            [ngStyle]="{'--icon-size': iconSize + 'px'}"
            [src]="relativeIconPath ? 'assets/icons/' + item.icon : item.icon"
          ></svg-icon>
        } @else {
          <img [src]="relativeIconPath ? 'assets/icons/' + item.icon : item.icon" alt="" />
        }
      </div>
    }

    @if (item.unreadState) {
      <div class="unread-state-wrapper">
        <div class="unread-state"></div>
      </div>
    }

    <div class="option-content" 
      [ngClass]="{
        'option-content--simple': variant === 'simple',
        'option-content--disabled': item.disabled,
      }"
    >
      <div class="option-title" [ngClass]="{'option-title--simple': variant === 'simple', 'option-title--bold': fontType === 'bold'}">
        @if (autoTranslate) {
          <span>{{ item.title | translate }}</span>
          @if (item.appendTitle) {
            <span class="option-append-title"> {{ item.appendTitle | translate }}</span>
          }
        }
        @else {
          <span>{{ item.title }}</span>
          @if (item.appendTitle) {
            <span class="option-append-title"> {{ item.appendTitle }}</span>
          }
        }
        <!-- todo: enable tooltip, https://gitlab.com/dfcz/bwm-frontend/-/issues/2 -->
        @if (item.explainTooltip) {
          <span class="option-title-tooltip">
            <svg-icon
              src="assets/icons/question-mark-circle.svg"
            ></svg-icon>
          </span>
        }
      </div>
      @if (variant === 'default') {
        <div class="option-description">
          @if (item.descriptionTemplate) {
              <ng-container *ngTemplateOutlet="item.descriptionTemplate"></ng-container>
          } @else if (item.description) {
            @if (autoTranslate) {
              {{ item.description | translate }}
            }
            @else {
              {{ item.description }}
            }
          }
        </div>
      }
    </div>

    <div 
      class="option-link" 
      [ngClass]="{
        'option-link--simple': variant === 'simple',
        'option-link--highlighted': highligtedValue && item.selectedValue && item.selectedValue === highligtedValue,
        'option-link--disabled': item.disabled,
      }"
    >
      <!-- todo: add real condition and routing -->
      @if (item.route || true) {
        <svg-icon
          [src]="'assets/icons/arrow-link.svg'"
        ></svg-icon>
      }
    </div>

  </a>
  @if (variant === 'default' && (!last || displayLastDivider)) {
    <nz-divider
      class="option-divider--default"
      [ngClass]="{'option-divider--highlighted': highligtedValue && item.selectedValue && item.selectedValue === highligtedValue}"
    ></nz-divider>
  }
}
